import { axiosV2 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';

type GetOperationsByTypes = {
  societyId: string;
  operationTypes: string[];
  fields?: string;
  items?: number;
};

export const getOperationsByTypes = async ({
  societyId,
  operationTypes,
  fields = '',
  items = 100,
}: GetOperationsByTypes) => {
  const query = {
    params: { societyId, filterBy: operationTypes, fields, items },
  };

  try {
    const { data } = await axiosV2.get('/operations', query);

    const decodedData = await decryptResponse(data);

    return decodedData;
  } catch (error) {
    return [];
  }
};
